import NoPhotoImg from "public/images/no-photo.png";

import { linkAssemblers } from "@/lib/unified-dtos/unified-media-mapper/helpers";

type PhotoSrcs = {
  small: string;
  medium: string;
  large: string;
};

export const CreatePhotoMixInFromMediaName = (
  mediaName?: string,
): PhotoSrcs => {
  const picturePlug = (NoPhotoImg as StaticAssetWithSrc).src;

  return mediaName
    ? {
        small: linkAssemblers.safeMakePhotoThumbnailSmall({ mediaName }),
        medium: linkAssemblers.safeMakePhotoThumbnailMedium({ mediaName }),
        large: linkAssemblers.safeMakePhotoUrl({ mediaName }),
      }
    : {
        small: picturePlug,
        medium: picturePlug,
        large: picturePlug,
      };
};
